/* global lpia_params */

import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

class ExtendedChoices extends Choices {
  _unselectChoiceIfSelected(choice) {
    const values = this.getValue(true);
    const value = choice.value;
    if (values.includes(value)) {
      setTimeout(() => this.removeActiveItemsByValue(value));
    }
  }
}

const jobsListContainer = document.querySelector('.js-jobs-list-list');
const jobsListAllItems = document.querySelectorAll('.js-jobs-list-item');
const loadMore = document.querySelector('.js-jobs-list-load-more');
let totalItems = jobsListAllItems.length;
let jobsListChoices, loadItems, loadedItemsInitial, loadMoreSpan;
if (jobsListContainer) {
  loadedItemsInitial = parseInt(jobsListContainer.getAttribute('data-initial-items-count'));
  loadItems = parseInt(jobsListContainer.getAttribute('data-loadmore-items-count'));
}
let loadedItems = loadedItemsInitial;
setLoadMoreNumber();

const jobsListSelect = document.querySelector('.js-jobs-list-select');
if (jobsListSelect) {
  jobsListChoices = new ExtendedChoices(jobsListSelect, {
    removeItemButton: true,
    renderSelectedChoices: 'always',
    callbackOnCreateTemplates: function (template) {
      return {
        choice: (choice, data) => {
          let itemValue = JSON.parse(data.value);
          return template(`
          <div class='${choice.classNames.item} ${choice.classNames.itemChoice} ${data.disabled ? choice.classNames.itemDisabled : choice.classNames.itemSelectable} ${
            data.selected ? choice.classNames.selectedState : ''
          }' data-select-text='${this.config.itemSelectText}' data-choice ${
            data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'
          } data-id='${data.id}' data-value='${itemValue['termId']}' ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
            ${data.label} <span class='text-neutral-alt text-primary-normal-12 ml-auto'>${itemValue['positions']}</span>
          </div>
        `);
        },
      };
    },

    callbackOnInit() {
      const element = this.passedElement.element;
      element.addEventListener('choice', (evt) => this._unselectChoiceIfSelected(evt.detail.choice));
      element.addEventListener(`hideDropdown`, () => this.clearInput());
    },
  });

  jobsListChoices.passedElement.element.addEventListener(
    'removeItem',
    function () {
      let filteredItems = filterTerms(jobsListChoices);
      totalItems = filteredItems.length;
      loadedItems = loadedItemsInitial;
      setItems(filteredItems);
    },
    false,
  );

  jobsListChoices.passedElement.element.addEventListener(
    'change',
    function () {
      let filteredItems = filterTerms(jobsListChoices);
      totalItems = filteredItems.length;
      loadedItems = loadedItemsInitial;
      setItems(filteredItems);
    },
    false,
  );
}

if (loadMore) {
  checkLoadMoreButtonVisibility();
  loadMore.addEventListener('click', function (e) {
    e.preventDefault();
    let filteredItems = filterTerms(jobsListChoices);
    totalItems = filteredItems.length;
    loadedItems += loadItems;
    setItems(filteredItems);
  });
}

function setItems(filteredItems) {
  hideAllItems();
  showItems(filteredItems, loadedItems);
  setLoadMoreNumber();
  checkLoadMoreButtonVisibility();
}

function setLoadMoreNumber() {
  if (loadMore) {
    loadMoreSpan = loadMore.querySelector('span');
    let loadMoreItems = loadItems;

    if (totalItems - loadedItems < loadItems) {
      loadMoreItems = totalItems - loadedItems;
    }

    if (loadMoreItems >= 2 && loadMoreItems <= 4) {
      loadMoreSpan.innerHTML = lpia_params.translations.jobList[3].replace('%s', loadMoreItems);
    } else if (loadMoreItems >= 5) {
      loadMoreSpan.innerHTML = lpia_params.translations.jobList[5].replace('%s', loadMoreItems);
    }
  }
}

function hideAllItems() {
  jobsListAllItems.forEach((item) => {
    item.classList.add('hidden');
  });
}

function showItems(filteredItems) {
  for (let i = 0; i <= filteredItems.length; i++) {
    filteredItems[i]?.classList?.remove('hidden');
  }
}

function checkLoadMoreButtonVisibility() {
  if (loadedItems < totalItems) {
    loadMore.classList.remove('!hidden');
  } else {
    loadMore.classList.add('!hidden');
  }
}

function filterTerms(jobsListChoices) {
  let jobsListValues = jobsListChoices.getValue(true);
  let filteredItems = [];

  // Reset jobs
  if (jobsListValues.length === 0) {
    if (jobsListAllItems) {
      jobsListAllItems.forEach((item) => {
        filteredItems.push(item);
      });
    }
    return filteredItems;
  }

  // Show selected jobs
  if (jobsListValues) {
    jobsListAllItems.forEach((item) => {
      jobsListValues.forEach((term) => {
        term = JSON.parse(term);
        term = term['termId'];
        if (item.classList.contains(`js-jobs-list-term-${term}`)) {
          if (!filteredItems.includes(item)) {
            filteredItems.push(item);
          }
        }
      });
    });
  }

  return filteredItems;
}
